export abstract class IntellisenseError {
  protected constructor(public readonly errorMessage: string) {}
}

export class ColumnMissingIntellisenseError extends IntellisenseError {
  constructor(
    errorMessage: string,
    public readonly columnId: string,
  ) {
    super(errorMessage);
  }
}

export class InputMissingIntellisenseError extends IntellisenseError {
  constructor(
    errorMessage: string,
    public readonly inputName: string,
  ) {
    super(errorMessage);
  }
}

export class InvalidFieldValueIntellisenseError extends IntellisenseError {
  constructor(
    errorMessage: string,
    public readonly fieldId: string,
  ) {
    super(errorMessage);
  }
}

export class ScopeVarMissingIntellisenseError extends IntellisenseError {
  constructor(
    errorMessage: string,
    public readonly varName: string,
  ) {
    super(errorMessage);
  }
}

export class TagMissingIntellisenseError extends IntellisenseError {
  constructor(
    errorMessage: string,
    public readonly tagId: string,
  ) {
    super(errorMessage);
  }
}

export class InvalidFormulaIntellisenseError extends IntellisenseError {
  constructor(errorMessage: string) {
    super(errorMessage);
  }
}
